var _circle, _circle2, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 282,
    viewBox: "0 0 263 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.224,
    cy: 100.772,
    r: 131.977,
    transform: "rotate(-150 181.224 100.772)",
    fill: "#232531"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1736_3716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: -32,
    width: 265,
    height: 265
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.224,
    cy: 100.772,
    r: 131.977,
    transform: "rotate(-150 181.224 100.772)",
    fill: "#232531"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1736_3716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.16 179.683C216.852 186.765 206.438 188.444 198.225 183.702L99.5841 126.752C91.3708 122.01 87.6172 112.151 90.5968 103.148L156.457 -95.8712L362.585 23.1371L223.16 179.683Z",
    fill: "#D3EDFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.691 82.6878C173.593 82.8711 171.743 81.3184 171.56 79.2198C171.338 76.6815 170.247 73.4583 168.136 71.5318C166.373 69.9235 163.176 68.5566 156.928 70.9976C154.965 71.7642 152.753 70.795 151.987 68.8329C151.22 66.8707 152.189 64.6586 154.151 63.8919C162.463 60.6447 168.905 61.9071 173.278 65.8962C177.301 69.5673 178.841 74.9098 179.159 78.556C179.343 80.6546 177.79 82.5045 175.691 82.6878ZM223.26 110.151C221.162 110.334 219.312 108.781 219.128 106.683C218.907 104.144 217.816 100.921 215.705 98.9948C213.942 97.3864 210.744 96.0195 204.496 98.4606C202.534 99.2272 200.322 98.258 199.555 96.2958C198.789 94.3336 199.758 92.1215 201.72 91.3549C210.032 88.1076 216.474 89.37 220.846 93.3592C224.87 97.0302 226.41 102.373 226.728 106.019C226.912 108.118 225.359 109.967 223.26 110.151ZM208.204 55.5674C205.285 53.8821 201.553 54.8822 199.868 57.8012C198.182 60.7202 199.182 64.4528 202.101 66.138C205.02 67.8233 208.753 66.8232 210.438 63.9042C212.124 60.9852 211.123 57.2526 208.204 55.5674Z",
    fill: "#232531"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSmile);
export default __webpack_public_path__ + "static/media/blue-smile.7a5d44fbc4a1a990160d5dcaf75c8548.svg";
export { ForwardRef as ReactComponent };